import { createSelector } from '@reduxjs/toolkit';
import { EKitchenStove } from '../../../../packages/JsonQuery';
import { selectKitchenStove } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Газовая', value: EKitchenStove.Gas },
  { label: 'Электрическая', value: EKitchenStove.Electric },
];

export const selectKitchenStoveFilter = createSelector(selectKitchenStove, value => ({
  label: 'Кухонная плита',
  value: [value],
  options: OPTIONS,
}));
